import React from 'react';
import { TARIFF_CATEGORIES, UNTAGGED_LABEL } from './constants';
import { CategorySelectBox } from './blocks';

// Untagged is the empty option and saves as null.
const CategorySelect = ({ value, onChange }) => (
    <CategorySelectBox aria-label="Category" value={value || ''} onChange={(e) => onChange(e.target.value || null)}>
        <option value="">{UNTAGGED_LABEL}</option>
        {TARIFF_CATEGORIES.map((category) => (
            <option key={category.value} value={category.value}>
                {category.label}
            </option>
        ))}
    </CategorySelectBox>
);

export default CategorySelect;
